export default __webpack_public_path__ + "static/media/file-zip.3edc5920.svg";